export default "__VITE_ASSET__ae5f83a5__"